var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApprovedSkills(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 26,
    fill: "#5F6F7C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1881_16227)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9054 29.5247C23.344 29.5247 25.3209 27.5458 25.3209 25.1046C25.3209 22.6635 23.344 20.6846 20.9054 20.6846C18.4668 20.6846 16.49 22.6635 16.49 25.1046C16.49 27.5458 18.4668 29.5247 20.9054 29.5247Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6669 18.7743C38.5371 18.6243 38.3822 18.5043 38.1974 18.4193C37.5431 18.1143 36.704 18.3593 36.2694 19.0344C36.2594 19.0494 36.2394 19.0544 36.2245 19.0544C30.0459 17.3893 23.8672 15.7293 17.6836 14.0643C17.1892 13.9343 16.6547 13.9993 16.2301 14.2793C15.7556 14.5943 15.411 15.0543 15.2911 15.5843C15.1363 16.2593 15.3411 17.0143 15.7906 17.4693C15.9305 17.6093 16.2301 17.9093 16.5748 17.8293C16.8695 17.7643 17.0243 17.4593 17.0593 17.3843C17.2841 16.5493 17.5138 15.7043 17.7436 14.8643C23.8323 16.4743 29.926 18.0843 36.0147 19.6944C35.5252 20.7594 35.0357 21.8244 34.5412 22.8894C34.5162 22.8944 34.4863 22.9044 34.4563 22.9144C34.3314 22.9594 34.2465 23.0194 34.2365 23.0294C34.1316 23.1044 28.5624 26.5645 20.8254 31.3745C20.6356 31.5245 20.1361 31.9695 19.9413 32.7245C19.8264 33.1796 19.8614 33.5646 19.9063 33.7996C21.0801 37.9296 22.2539 42.0547 23.4227 46.1847L14.3171 60.625C13.7128 61.585 13.9975 62.86 14.9565 63.465C15.2961 63.68 15.6757 63.785 16.0503 63.785C16.7346 63.785 17.3989 63.445 17.7935 62.825L27.3137 47.7198L27.3337 61.945C27.3337 63.08 28.2577 64 29.3915 64C29.3915 64 29.3915 64 29.3965 64C30.5304 64 31.4544 63.075 31.4494 61.94C31.4394 55.8899 31.4344 49.8448 31.4244 43.7947C30.83 40.9047 30.5154 39.3496 29.921 36.4596C29.916 36.4496 29.921 36.4346 29.931 36.4246C31.3145 34.6496 32.7031 32.8796 34.0867 31.1095C34.1516 31.0245 34.2065 30.9345 34.2515 30.8345C35.7899 27.3345 37.3283 23.8294 38.8667 20.3294C39.0915 19.8094 39.0365 19.1944 38.6669 18.7743ZM31.7841 29.1495C30.895 29.5945 30.0059 30.0445 29.1168 30.4895C29.1168 30.1895 29.1168 29.8845 29.1168 29.5845C30.2407 28.8945 31.3645 28.2095 32.4883 27.5195C32.2536 28.0645 32.0188 28.6045 31.7841 29.1495Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1881_16227"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(14 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovedSkills);
export default __webpack_public_path__ + "static/media/ApprovedSkills.99de9a05a941393cdf6cc22c0c1f4757.svg";
export { ForwardRef as ReactComponent };